import React, { useEffect, useRef } from 'react';
import SkeletonKeyUpdates from 'components/Dashboard/KeyUpdates/SkeletonKeyUpdates';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import SavedItemElements from './SavedItemElements';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import { useSavedItemsContext } from 'components/SavedItems/SavedItemsContext';

const FolderItems = (props) => {
  const { state, setState } = useSavedItemsContext();
  const { scrollPositionSavedItems, savedItems, isLoadingFolder } = state;
  const { currentFolder, filtersResources, setFiltersResources, loadFolderItems } = props;
  const [heightContainer, containerRef] = useHeightContainer();

  const scrollBarRef = useRef(null);

  const rememberScrollPosition = () => {
    setState('scrollPositionSavedItems', scrollBarRef.current.view?.scrollTop);
  };

  const scrollRestoration = useRef(null);
  scrollRestoration.current = () => {
    if (scrollPositionSavedItems !== null && !isLoadingFolder) {
      scrollBarRef.current?.scrollTop(scrollPositionSavedItems);
    }
  };

  useEffect(() => {
    scrollRestoration.current();
  }, [isLoadingFolder, scrollBarRef.current]);

  const finalHits = () => {
    return savedItems.map((item) => {
      let itemContent = { ...item.content };
      if (item.contentType === 'UserContent') {
        itemContent.link = `${itemContent.contentUrl}`;
        itemContent.organisation = itemContent[`creatorOrganisation`];
        itemContent.organisationWebsite = itemContent[`creatorOrganisationWebsite`];
        itemContent.imageUrl = itemContent[`creatorOrganisationLogo`];
      }
      return {
        ...itemContent,
        savedItemid: item.id,
      };
    });
  };

  return (
    <div className='pt-5'>
      {isLoadingFolder && <SkeletonKeyUpdates />}
      {!isLoadingFolder && (
        <>
          {savedItems.length === 0 && (
            <div className='pt-2'>
              <div className='box-top-rounded pt-5' ref={containerRef} style={{ height: `${heightContainer}px` }}>
                <div className='pt-5 text-center'>
                  <p className='text-center mt-5 pt-5 title-h4 main-light-text px-5'>
                    {filtersResources.length > 0
                      ? 'No saved items in this folder matching your filters'
                      : 'Content you save to this folder will appear here'}
                  </p>
                  {filtersResources.length > 0 && (
                    <button
                      className={`general-button action-button empty-button third-button`}
                      onClick={() => {
                        setFiltersResources([]);
                        loadFolderItems(currentFolder.id);
                      }}
                    >
                      Clear filters
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {savedItems.length > 0 && (
            <div className='saved-items-main-list'>
              <div ref={containerRef} />
              <CustomScrollbar
                className={'main-content-scrollbar'}
                style={{ height: `${heightContainer}px` }}
                maximalThumbYSize={100}
                ref={scrollBarRef}
              >
                <div className='py-2'>
                  <SavedItemElements hits={finalHits()} rememberScrollPosition={rememberScrollPosition} />
                </div>
              </CustomScrollbar>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FolderItems;
